// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_op-0";
export var buttonContainer = "_op-3";
export var cancelButton = "_op-4";
export var headerSection = "_op-6";
export var headerTitle = "_op-9";
export var messageSideLeft = "_op-1";
export var messageSideRight = "_op-2";
export var orderNumberContainer = "_op-7";
export var orderNumberLabel = "_op-8";
export var submitButton = "_op-5";